export default "__VITE_ASSET__ZuFOPBZZ__"